/**
 *
 */
const displayUnderWritingQueue = () =>
{
	const shortcodeDivs = document.querySelectorAll( '[data-underwriting-queue]' );

	shortcodeDivs.forEach( mainContent =>
	{
		const submissions   = [];
		const resubmissions = [];

		if (mainContent instanceof HTMLElement) {
			if (mainContent.children instanceof HTMLCollection) {

				for (let elem of mainContent.children) {

					let text                  = elem.textContent;
					const resubmissionMatches = text.match( /Underwriting\s+Resubmissions.*?(\d+ Loans?)/i );

					if (resubmissionMatches && resubmissionMatches.length === 2) {

						resubmissions.push( resubmissionMatches[1] );
						text = text.replace( resubmissionMatches[0], '' );

						const submissionsMatches = text.match( /^.*Underwriting\s+Initial\s+Submissions\s+/is );

						if (submissionsMatches && submissionsMatches.length === 1) {

							text = text.replace( submissionsMatches[0], '' );

							text.split( "\n" )
								.filter( line => line.replace( /\s+/g, '' ) !== '' )
								.forEach( line => submissions.push( line ) );
						}
					}
				}
			}
		}

		if (submissions.length || resubmissions.length) {
			mainContent.innerHTML = `
				<h3>Underwriting Initial Submissions</h3>
				${submissions.map( txt => `<p>${txt}</p>` ).join( '' )}
				<h3>Underwriting Resubmissions</h3>
				${resubmissions.map( txt => `<p>${txt}</p>` ).join( '' )}
			`;
		}
	} );
};

/**
 *
 */
export default displayUnderWritingQueue;